<template>
    <div :class="['form-text-area',{'focus': focus}]">
        <div :class="['input-label',{'active': inputValue}]" @click="focused()">{{label}}</div>
        <textarea
                v-bind:rows="rows"
                ref="input"
                @focus="focus = true"
                @blur="focus = false"
                v-model="inputValue">
        </textarea>
    </div>
</template>

<script>

    export default {
        name: "form-text-area",
        data() {
            return {
                inputValue: "",
                focus: false,
            }
        },
        props: {
            rows: {
              type: [String, Number],
              default: "1"
            },
            value: {
                type: [String, Number],
                default: ""
            },
            label: {
                type: String,
                default: "label"
            },
            parentFocus: {
                type: Boolean,
                default: false
            }
        },
        mounted() {
            this.inputValue = this.value;
        },
        methods: {
            focused() {
                this.$refs.input.focus();
            }
        },
        watch: {
            inputValue(val) {
                this.$emit("input", val)
            },
            parentFocus(val){
                if (val){
                    this.focused();
                }
            },
            focus(val) {
                if (!val)
                    this.$emit("blur", true);
                else
                    this.$emit("focus", true);
            },
        }
    }
</script>

<style scoped>
    .form-text-area {
        position: relative;
    }
    .form-text-area textarea {
        width: 100%;
        outline: none;
        border: none;
        border-bottom: 1px solid #aaa;
        padding: 5px 0;
        margin-top: 20px;
        font-weight: 500;
        font-size: 15px;
        color: #1D1D1D;
        resize: none;
    }
    .form-text-area textarea {
        box-shadow: inset 0 0 0 50px var(--white-color);
    }
    .form-text-area:before{
        content: "";
        position: absolute;
        bottom: 4px;
        left: 50%;
        width: 0;
        height: 2px;
        background-color: var(--primary-color);
        transition: all .4s;
    }
    .focus.form-text-area:before {
        left: 0;
        width: 100%;
    }
    .form-text-area .input-label {
        position: absolute;
        top: calc(50% + 10px);
        transform: translateY(-50%);
        font-size: 15px;
        color: var(--lighten-5-color);
        z-index: 1;
        transition: all .2s;
    }
    .form-text-area .input-label.active {
        top: 6px;
        transform: translateY(0);
        font-size: 13px;
        font-weight: 300;
    }
    .form-text-area.focus .input-label {
        top: 6px;
        transform: translateY(0);
        font-size: 13px;
        font-weight: 300;
        color: var(--primary-color);
    }
</style>
